export const defaultMinTimeBeforeBookingCanBeEditedInDays = 2;

export interface BookingDetailsTileProps {
    targetRoute?: string;
}

export const TOAST_PARAM_ON_UPDATE = "on-update";
